<template>
  <div class="orderAddNew">
    <QS-scroller-box>
      <QS-h3-title>
        <template slot="title"
          >新增采购订单</template
        >
      </QS-h3-title>
      <!--来源信息 -->
      <originInfo ref="originInfo" />
      <!-- 合同信息 -->
      <contractInfo ref="contractInfo" />
      <!-- 支付信息 -->
      <paymentInfo ref="paymentInfo" />
      <template slot="bottomAction">
        <el-button size="mini" @click="goBack">取消</el-button>
        <el-button
          size="mini"
          type="primary"
          :loading="submitLoading"
          @click="addPurchaseOrder('onlyCreate')"
          >创建</el-button
        >
        <el-button
          size="mini"
          type="primary"
          :loading="submitLoading"
          @click="addPurchaseNext('next')"
          >下一步</el-button
        >
      </template>
    </QS-scroller-box>
  </div>
</template>
<script>
import originInfo from '../components/originInfo.vue'
import contractInfo from '../components/contractInfo.vue'
import paymentInfo from '../components/paymentInfo.vue'
// eslint-disable-next-line import/no-cycle
import { doPurchaseOrderSignCheck } from '@/api/domain/purchase.js'

export default {
  components: { originInfo, contractInfo, paymentInfo },
  name: 'OrderAdd',
  data() {
    return {
      submitLoading: false,
    }
  },
  methods: {
    // 获取表单数据
    getParams() {
      const originInfoObj = this.$refs.originInfo.carLease_obj
      const contractInfoObj = this.$refs.contractInfo.contractInfo_obj
      const paymentInfoObj = this.$refs.paymentInfo.paymentInfo_obj
      return {
        ...originInfoObj,
        ...contractInfoObj,
        ...paymentInfoObj,
      }
    },
    // 表单校验
    validateFun() {
      // 来源信息表单校验
      let originInfoFlag = false
      // 合同信息表单校验
      let contractInfoFlag = false
      this.$refs.originInfo.$refs.FormTextBox.getRefs().validate((valid) => {
        originInfoFlag = valid
      })
      this.$refs.contractInfo.$refs.contract_info_obj.validate((valid) => {
        contractInfoFlag = valid
      })
      // 合同附件的表单校验提示显示单独控制，不影响表单校验结果
      this.$refs.contractInfo.validContract()
      return originInfoFlag && contractInfoFlag
    },
    /**
     * 创建采购订单
     * @param {nextStep(下一步),onlyCreate-创建} isNextFlag
     */
    async addPurchaseOrder(isNextFlag) {
      if (!this.validateFun()) return
      this.submitLoading = true
      const purchaseOrderAddParam_add = {
        ...this.getParams(),
      }
      purchaseOrderAddParam_add.contractAttachment = this.getUoloadCommonFileData(
        purchaseOrderAddParam_add.contractAttachment,
      )
      delete purchaseOrderAddParam_add.purchaseModeName
      delete purchaseOrderAddParam_add.payName
      delete purchaseOrderAddParam_add.contractDate
      delete purchaseOrderAddParam_add.customerName
      const res = await doPurchaseOrderSignCheck(purchaseOrderAddParam_add)
      this.submitLoading = false
      if (res.code !== 1) return false // 添加失败
      this.$message.success('新增采购订单成功')
      if (isNextFlag === 'nextStep') { return { enableAddCar: true, response: res.data } } // 添加成功，可进行添加车辆
      this.$refreshBack(true)
      this.$router.push('/purchaseNew/purchaseOrder/list')
    },
    // 下一步
    async addPurchaseNext() {
      if (!this.validateFun()) return
      // 先创建采购订单，创建成功后再进行添加车辆的操作
      const created = await this.addPurchaseOrder('nextStep') // 采购订单添加成功返回数据对象，失败返回false
      if (!created) return // 采购订单添加成功再进行添加车辆
      const originInfoObj = this.$refs.originInfo.carLease_obj || {}
      const contractInfoObj = this.$refs.contractInfo.contractInfo_obj || {}
      const mixObj = {
        ...originInfoObj,
        ...contractInfoObj,
        id: created.response.id,
        providerId: created.response.providerId,
      }
      this.$router.push({
        path: '/purchaseNew/purchaseOrder/add/addCar',
        query: {
          mixInfo: JSON.stringify(mixObj),
        },
      })
    },
    goBack() {
      this.$refreshBack(false)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  width: 205px;
}
</style>
